// extracted by mini-css-extract-plugin
module.exports = {"listItem":"DeckCategory_listItem__e3xhg"};